<div class="date-row">
    <button
        type="button"
        class="icon-btn"
        [title]="'common.previous-day' | translate"
        [disabled]="isLoadingPlan"
        (click)="changeDate.emit(-1)"
    >
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>

    <div
        class="date-row__center"
        bsDatepicker
        placement="bottom"
        [container]="datepickerContainer"
        [bsValue]="deliveryDate"
        [bsConfig]="datepickerConfig"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [isDisabled]="isLoadingPlan"
        (bsValueChange)="onDatePicked($event)"
    >
        <small>{{ 'common.delivery-date' | translate }}</small>
        <b>{{ formatDate(deliveryDate) }}</b>
    </div>

    <button
        type="button"
        class="icon-btn"
        [title]="'common.next-day' | translate"
        [disabled]="isLoadingPlan"
        (click)="changeDate.emit(1)"
    >
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>

    <div class="date-row__spinner">
        <span
            *ngIf="isLoadingPlan"
            class="spinner-border spinner-border-sm text-primary"
            role="status"
        ></span>
    </div>
</div>

<hr />

<div class="search">
    <i class="fa fa-search search__icon" aria-hidden="true"></i>
    <input
        type="text"
        class="form-control search__input"
        [placeholder]="'delivery-plan-viewer.search-order-code' | translate"
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchChanged($event)"
    />
    <button
        *ngIf="normalizedQuery"
        type="button"
        class="icon-btn search__clear"
        [title]="'common.clear-search' | translate"
        (click)="onSearchChanged('')"
    >
        <i class="fa fa-times" aria-hidden="true"></i>
    </button>
</div>

<h5 class="section-title">
    {{ 'delivery-plan-viewer.orders-count' | translate: { count: sortedOrders.length } }}
</h5>

<div class="list">
    <p *ngIf="sortedOrders.length === 0 && normalizedQuery" class="list__empty">
        {{ 'common.no-results' | translate }}
    </p>

    <div
        *ngFor="let order of sortedOrders; trackBy: trackByCode"
        class="order-card"
        [class.is-selected]="order.code === selectedOrderCode"
        (click)="onOrderClicked(order)"
    >
        <div class="order-card__main">
            <div class="order-card__code">
                <span>{{ order.code }}</span>
                <button
                    type="button"
                    class="icon-btn icon-btn--small"
                    [title]="'common.copy' | translate"
                    (click)="onCopyClicked($event, order.code)"
                >
                    <i class="fa fa-copy" aria-hidden="true"></i>
                </button>
            </div>
            <!-- Address: not returned by the API yet, so this line does not show for now. -->
            <div *ngIf="order.address">{{ order.address }}</div>

            <div *ngIf="order.courierName; else unassignedLabel" class="order-card__courier">
                {{ 'delivery-plan-viewer.courier-name' | translate: { name: order.courierName } }}
            </div>
            <ng-template #unassignedLabel>
                <div class="order-card__unassigned">{{ 'delivery-plan-viewer.unassigned' | translate }}</div>
            </ng-template>

            <div *ngIf="order.pickupEta || order.deliveryEta" class="order-card__eta">
                <ng-container *ngIf="order.pickupEta">
                    {{ 'delivery-plan-viewer.pickup-time' | translate: { time: formatTime(order.pickupEta) } }}
                </ng-container>
                <ng-container *ngIf="order.pickupEta && order.deliveryEta"> · </ng-container>
                <ng-container *ngIf="order.deliveryEta">
                {{ 'delivery-plan-viewer.delivery-time' | translate: { time: formatTime(order.deliveryEta) } }}
                </ng-container>
            </div>
        </div>
        <!-- Delete icon: removes the card from this list only (no API call, markers stay). -->
        <button
            type="button"
            class="icon-btn order-card__delete"
            [title]="'delivery-plan-viewer.remove-from-list' | translate"
            (click)="onDeleteClicked($event, order.code)"
        >
            <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
    </div>
</div>

<ng-container *ngIf="unassigned.length > 0">
    <hr />
    <div class="unassigned-head" (click)="showUnassigned = !showUnassigned">
        <h5 class="section-title section-title--danger">
            {{ 'delivery-plan-viewer.unassigned-orders-count' | translate: { count: filteredUnassigned.length } }}
        </h5>
        <div class="unassigned-head__actions">
            <button
                type="button"
                class="icon-btn unassigned-head__map-toggle"
                [class.is-active]="showUnassignedOnMap"
                [disabled]="!canToggleUnassignedOnMap"
                [attr.aria-pressed]="showUnassignedOnMap"
                [title]="'delivery-plan-viewer.show-unassigned-on-map' | translate"
                (click)="onToggleUnassignedOnMapClicked($event)"
            >
                <i class="fa fa-map-marker" aria-hidden="true"></i>
            </button>
            <i
                class="fa unassigned-head__icon"
                [class.fa-chevron-up]="showUnassigned"
                [class.fa-chevron-down]="!showUnassigned"
                aria-hidden="true"
            ></i>
        </div>
    </div>

    <div *ngIf="showUnassigned" class="list">
        <p *ngIf="filteredUnassigned.length === 0 && normalizedQuery" class="list__empty">
            {{ 'common.no-results' | translate }}
        </p>

        <div
            *ngFor="let order of filteredUnassigned; trackBy: trackByCode"
            class="order-card order-card--unassigned"
            [class.order-card--clickable]="hasLocation(order)"
            [class.is-selected]="hasLocation(order) && order.code === selectedOrderCode"
            (click)="onUnassignedClicked(order)"
        >
            <div class="order-card__code">
                <span>{{ order.code }}</span>
                <button
                    type="button"
                    class="icon-btn icon-btn--small"
                    [title]="'common.copy' | translate"
                    (click)="onCopyClicked($event, order.code)"
                >
                    <i class="fa fa-copy" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</ng-container>